export default __webpack_public_path__ + "static/media/text-cursor.df10f178.png";